import React from 'react'
import Icon from "../../../components/atoms/Icon";

const SubscriptionStatusComponent = ({iconName, onFocus, id, type, placeholder, value}) => {
    return (

        <div className="flex flex-row bg-gray-chart-200 w-full px-3.5 gap-2.5 items-center rounded-sm  h-12.6">
            <Icon iconName={iconName}/>

            <input
                readOnly={true}
                onFocus={onFocus}
                id={id}
                type={type}
                placeholder={placeholder}
                className="bg-gray-chart-200 outline-none text-dark-blue-200 text-13 py-3.5 w-full"


                value={value}
                //   onChange={}
            />

        </div>
    )
}

export default SubscriptionStatusComponent
